import React from "react"
import { Button, Form, Select, Input, DatePicker, Space } from 'antd';
import { HighEquipments, HomeAbout, HomeAppointment, HomeBlog, HomeExperience, PatientFeedback, ServiceCard, ServiceHeader } from "../../ThirdComponents";
const { Option } = Select
const ThirdHome = (props) => {
    const { selectedLanguage } = props
    const onFinish = async (values) => {
        let formData = new FormData()
        console.log('formData', values)
    }
    const handleChange = (value) => {
        console.log(`Selected: ${value}`);
    };

    const onChange = (date, dateString) => {
        // console.log(date, dateString);
    };
    return (
        <div className="third-design-home-main">
            <div className="third-design-home-bg-section">
                <div className="third-design-home-bg-overlay"></div>
                <div className="third-design-home-bg-section-text-div-main">
                    <div className="third-design-home-bg-section-text-div">
                        <h2 data-aos="fade-right"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1000">{selectedLanguage?.txt_excellent_techniques_for_healthy_dental_condition}</h2>
                        <p data-aos="fade-left"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1000">{selectedLanguage?.txt_important_to_take}</p>
                        <button data-aos="fade-right"
                            data-aos-easing="ease-out-cubic"
                            data-aos-delay="100"
                            data-aos-offset="0"
                            data-aos-duration="1000">{selectedLanguage?.txt_get_start}</button>
                    </div>
                </div>
            </div>
            <div className="third-design-appoint-form">
                <Form
                    labelCol={{ span: 24 }}
                    className='appointment-form'
                    name="basic"
                    onFinish={onFinish}
                >
                    <div className='third-design-appointment-form-time-div'>
                        <div>
                            <Form.Item
                                className="third-design-appointment-div"
                                name='name'
                                label={selectedLanguage?.name_label}
                            >
                                <Input className="third-design-appointment-inputs" placeholder={selectedLanguage?.name_label} />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item
                                className="third-design-appointment-div"
                                name='email'
                                label={selectedLanguage?.input_email_placeholder}
                            >
                                <Input className="third-design-appointment-inputs" placeholder={selectedLanguage?.input_email_placeholder} />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item
                                className="third-design-appointment-div"
                                name='service'
                                label={selectedLanguage?.service_heading}
                            >
                                <Select
                                    className="third-design-appointment-inputs third-design-appointment-select"
                                    showArrow
                                    showSearch
                                    allowClear
                                    placeholder={selectedLanguage?.service_heading}
                                    optionFilterProp='children'
                                    filterOption={true}
                                    onChange={handleChange}
                                >
                                    <Option value={'Teeth Whitening'}>{selectedLanguage?.txt_teeth_whitening}</Option>
                                    <Option value={'Teeth Checkup'}>{selectedLanguage?.txt_teeth_checkup}</Option>
                                    <Option value={'Orthodontics'}>{selectedLanguage?.txt_orthodontics}</Option>
                                    <Option value={'Dental Crown'}>{selectedLanguage?.txt_dental_crown}</Option>
                                    <Option value={'Dental Filling'}>{selectedLanguage?.txt_dental_filling_text}</Option>
                                </Select>
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item
                                className="third-design-appointment-div"
                                label={selectedLanguage?.txt_date}
                                name="date"
                            >
                                <Space direction="vertical" size={12}>
                                    <DatePicker className="third-design-appointment-inputs" placeholder={selectedLanguage?.txt_date} onChange={onChange} needConfirm />
                                </Space>
                            </Form.Item>
                        </div>
                        <div className='third-design-appointment-form-btn-div'>
                            <Form.Item
                                wrapperCol={{ span: 24, offset: 0 }}
                            >
                                <Button type="primary" htmlType="submit">
                                    {selectedLanguage?.txt_make_appointment}
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </div>
            <HomeAppointment {...props}/>
            <HomeAbout {...props}/>
            <HomeExperience {...props}/>
            <ServiceCard {...props}/>
            <HighEquipments {...props}/>
            <PatientFeedback {...props}/>
            <ServiceHeader {...props} title={selectedLanguage?.txt_our_blog} heading={selectedLanguage?.txt_latest_blog_and_articles} text={selectedLanguage?.txt_it_is_important_to_take_pain} />
            <HomeBlog {...props}/>
        </div>
    )
}

export default ThirdHome